import { z } from "zod/v4";

export const GoogleCallbackQueryParamSchema = z.object({
  code: z.string(),
  state: z.string(),
});
export type GoogleCallbackQueryParamType = z.infer<
  typeof GoogleCallbackQueryParamSchema
>;
